<div
  class="login-form"
  *ngIf="this.firstStep && !this.passwordExpiry && (!controlPasswordExpired || !this.LoggedInUserListCheck || (!controlPasswordExpired && !this.LoggedInUserListCheck))"
>
  <div class="row-login row">
    <!--Left div-->
    <div class="col-xs-12 col-sm-8 col-md-6 login-left">
      <div style="padding: 15px">
        <!--logo section -->
        <div class="row">
          <div class="container-fluid">
            <div class="login-header text-center">
              <img
                [src]="this.logoPath"
                class="logo"
                alt="able+"
                title="able+"
              />
              <h3 class="title hidden">able+</h3>
            </div>
          </div>
        </div>
        <!--logo section end-->
        <form
          name="form"
          (keydown)="onKeyDown($event, f.form.valid)"
          #f="ngForm"
          novalidate
        >
          <!--First step-->

          <div class="row" *ngIf="!this.nextStep">
            <div
              *ngIf="removeorganisationClicked"
              class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11"
            >
              <span class="input-group-addon">
                <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M5,3V21H11V17.5H13V21H19V3H5M7,5H9V7H7V5M11,5H13V7H11V5M15,5H17V7H15V5M7,9H9V11H7V9M11,9H13V11H11V9M15,9H17V11H15V9M7,13H9V15H7V13M11,13H13V15H11V13M15,13H17V15H15V13M7,17H9V19H7V17M15,17H17V19H15V17Z"
                  />
                </svg>
              </span>
              <div
                class="form-group label-floating is-empty"
                [ngClass]="{ 'has-error': f.submitted && !organisation.valid, 'is-empty': selectedOrganisationName == '' }"
              >
                <label class="control-label" [ngClass]="{ 'dirty-input-label ': selectedOrganisationName != null}">Organisation</label>
                <ng-container *ngIf="!isFromUniqueUrl">
                  <input
                  type="text"
                  list="organisations"
                  id="organisation"
                  class="form-control"
                   autocomplete="off"
                  name="organisation"
                  (input)="OnKeyPress($event.target.value)"
                  (change)="onOrgSelected()"
                  [(ngModel)]="loginModel.organisation"
                  #organisation="ngModel"
                  required
                />
                <datalist

                  *ngIf="organisationList.length > 0 && !!loginModel?.organisation"
                  id="organisations"
                >
                  <option  *ngFor="let org of organisationList">
                    {{ org.name }}
                  </option>
                </datalist>
                </ng-container>
              <ng-container *ngIf="isFromUniqueUrl">
                <div class="form-group label-floating is-empty">
                  <span
                    style="
                      color: #3c4043;
                      text-align: center;
                      font-size: 14px;
                      font-weight: 500;
                      letter-spacing: 0.25px;
                      font-family: Arial, Helvetica, sans-serif;">
                    <b>{{ organisationList[0].name }}</b>
                  </span>
                </div>
              </ng-container>
              </div>
            </div>

            <div
              *ngIf="!removeorganisationClicked"
              class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11"
            >
              <span class="input-group-addon" style="width: 65px; height: 66px">
                <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M5,3V21H11V17.5H13V21H19V3H5M7,5H9V7H7V5M11,5H13V7H11V5M15,5H17V7H15V5M7,9H9V11H7V9M11,9H13V11H11V9M15,9H17V11H15V9M7,13H9V15H7V13M11,13H13V15H11V13M15,13H17V15H15V13M7,17H9V19H7V17M15,17H17V19H15V17Z"
                  />
                </svg>
              </span>
              <div class="form-group label-floating is-empty">
                <span
                  style="
                    color: #3c4043;
                    text-align: center;
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 0.25px;
                    font-family: Arial, Helvetica, sans-serif;
                  "
                >
                  <b>{{ selectedOrganisationName }}</b>
                </span>
                <a *ngIf="!isFromUniqueUrl"
                  style="cursor: pointer; color: #3c4043"
                  class="pull-right"
                  (click)="onRemoveOrganisation()"
                  title="Remove organisation"
                >
                  <i class="material-icons">clear</i></a
                >
              </div>
            </div>
          </div>

          <div class="row" *ngIf="!this.nextStep">
            <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11">
              <span class="input-group-addon">
                <i class="material-icons">account_box</i>
              </span>
              <div
                class="form-group label-floating is-empty"
                [ngClass]="{'has-error': f.submitted && !username.valid, 'is-empty': username == ''}"
              >
                <label class="control-label">Username</label>
                <input
                  type="text"
                  class="form-control"
                  name="username"
                  [(ngModel)]="loginModel.username"
                  #username="ngModel"
                  required
                />
              </div>
            </div>
          </div>

          <div
            class="text-center margin-top-base padding-top-base"
            *ngIf="!this.nextStep"
          >
            <a

              class="btn btn-primary btn-block"
              [ngClass]="{ disabled: (organisationList.length < 1 || loadingOrganisationInfo) && !loginModel.username }"
              [ngStyle]="{ 'background-color': this.sharedService.ButtonColor.value, color: this.sharedService.TextButtonColor.value }"
              (click)="usernameValidation()"
              (keydown.enter)="usernameValidation()"
            >Next</a>
          </div>
          <!--first step end-->

          <!--Second step-->
          <div class="row" *ngIf="this.nextStep && !removeorganisationClicked">
            <hr />
            <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11">
              <span class="input-group-addon" style="width: 65px; height: 51px">
                <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M5,3V21H11V17.5H13V21H19V3H5M7,5H9V7H7V5M11,5H13V7H11V5M15,5H17V7H15V5M7,9H9V11H7V9M11,9H13V11H11V9M15,9H17V11H15V9M7,13H9V15H7V13M11,13H13V15H11V13M15,13H17V15H15V13M7,17H9V19H7V17M15,17H17V19H15V17Z"
                  />
                </svg>
              </span>
              <div class="form-group label-floating is-empty">
                <span
                  style="
                    color: #3c4043;
                    text-align: center;
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 0.25px;
                    font-family: Arial, Helvetica, sans-serif;
                  "
                >
                  <b>{{ selectedOrganisationName }}</b>
                </span>
                <a *ngIf="!isFromUniqueUrl"
                  style="cursor: pointer; color: #3c4043"
                  class="pull-right"
                  (click)="onRemoveOrganisation()"
                  title="Remove organisation"
                >
                  <i class="material-icons">clear</i>
                </a>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="this.nextStep">
            <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11">
              <span class="input-group-addon">
                <a>
                  <img
                    style="
                      float: left;
                      height: 35px;
                      width: 35px;
                      text-align: center;
                      vertical-align: middle;
                      margin: 10px 0 0 0;
                      border-radius: 50%;
                      overflow: hidden;
                    "
                    [src]="this.avatar"
                  />
                </a>
              </span>
              <div class="form-group label-floating is-empty">
                <span
                  style="
                    color: #3c4043;
                    text-align: center;
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 0.25px;
                    font-family: Arial, Helvetica, sans-serif;
                  "
                >
                  <b>{{ this.userNameValidated }}</b>
                </span>
                <a
                  style="cursor: pointer; color: #3c4043"
                  class="pull-right"
                  (click)="onRemoveAccount()"
                  title="Remove account"
                >
                  <i class="material-icons">clear</i>
                </a>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="!isLiberateUser && this.nextStep">
            <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11">
              <span class="input-group-addon">
                <i class="material-icons">lock</i>
              </span>
              <div
                class="form-group label-floating"
                [ngClass]="{ 'has-error': f.submitted && !password.valid, 'is-empty': password == '' }"
              >
                <label class="control-label">Password</label>
                <input
                  [type]="type"
                  class="form-control"
                  name="password"
                  [(ngModel)]="loginModel.password"
                  #password="ngModel"
                  required
                />
                <span
                  *ngIf="passwordMode"
                  title="Show password"
                  class="input-group-addon addon-right text-gray cursor-pointer"
                  (click)="passwordModeOff()"
                >
                  <i class="mdi mdi-eye"></i>
                </span>
                <span
                  *ngIf="!passwordMode"
                  title="Hide password"
                  class="input-group-addon addon-right text-gray cursor-pointer"
                  (click)="passwordModeOn()"
                >
                  <i class="mdi mdi-eye-off"></i>
                </span>
              </div>
            </div>
          </div>

          <div
            class="text-center margin-top-base padding-top-base"
            *ngIf="!isLiberateUser && this.nextStep"
          >
            <button
              type="button"
              (click)="f.form.valid && onUserLogin()"
              (keydown.enter)="f.form.valid && onUserLogin()"
              [disabled]="loading"
              class="btn btn-primary btn-block"
              [ngStyle]="{ 'background-color': this.sharedService.ButtonColor.value, color: this.sharedService.TextButtonColor.value}"
            >
              Login
            </button>
          </div>
          <!--second step end-->
        </form>

        <!--forgot password option-->
        <div class="footer text-center">
          <div class="small">
            <a
              *ngIf="this.firstStep && !this.nextStep"
              routerLink="/forgot-username"
              routerLinkActive="active"
            >Forgot username?</a>
            <a
              *ngIf="this.nextStep"
              routerLink="/forgot-password"
              routerLinkActive="active"
            >Forgot password?</a>
          </div>
        </div>
        <!--forgot password option end-->
      </div>

      <!--Liberate user-->
      <div class="row" *ngIf="isLiberateUser">
        <div class="container-fluid">
          <div class="loading-spinner-brand-blue-40"></div>
          <div class="card text-center bg-brand-blue text-white">
            <div class="card-content">
              You are being redirected to the UK Access Federation for authentication to allow you to access their resources.
            </div>
          </div>
        </div>
      </div>
      <!--Liberate user end-->
    </div>
    <!--Left div end-->

    <div class="circle-flex">
      <div class="circle-section">or</div>
    </div>

    <!--Right div-->
    <div class="col-xs-12 col-sm-4 col-md-6 login-right">
      <div style="padding: 15px">
        <div class="container-fluid">
          <div class="social-section col-md-12">
            <div
              class="row-social row btn"
              role="button"
              style="background-color: #3b5998; color: white; padding: 12px"
            >
              <div
                class="col-md-11 hidden-xs hidden-sm"
                (click)="onLoginWithSocialClick(SocialProviderNameEnum.Facebook)"
              >
                Facebook
              </div>
              <div class="col-md-1">
                <i class="fa fa-facebook fa-fw"></i>
              </div>
            </div>
            <div
              class="row-social row btn"
              role="button"
              style="background-color: #dd4b39; color: white; padding: 12px"
            >
              <div
                class="col-md-11 hidden-xs hidden-sm"
                (click)="onLoginWithSocialClick(SocialProviderNameEnum.Google)"
              >
                Google
              </div>
              <div class="col-md-1">
                <i class="fa fa-google fa-fw"></i>
              </div>
            </div>
            <div
              class="row-social row btn"
              role="button"
              style="
                background-color: rgb(40, 103, 178);
                color: white;
                padding: 12px;
              "
            >
              <div
                class="col-md-11 hidden-xs hidden-sm"
                (click)="onLoginWithSocialClick(SocialProviderNameEnum.LinkedIn)"
              >
                LinkedIn
              </div>
              <div class="col-md-1">
                <i class="fa fa-linkedin fa-fw"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Right div end-->
  </div>
</div>

<!--modal password expiry-->
<div *ngIf="passwordExpiry">
  <password-expiry
    *ngIf="peopleData != undefined"
    [userLogged]="peopleData"
    [passwordExpirySettings]="{
      hasExpired,
      checkFirstLogin,
      passwordExpiry,
      passwordDaysExpire
    }"
    (skip)="onSkip()"
    (reset)="onReset()"
  >
  </password-expiry>
</div>
<!--password expiry end-->

<!--last users accessed-->
<div *ngIf="this.LoggedInUserListCheck && !this.firstStep">
  <div>
    <div class="row">
      <div class="container-fluid">
        <div class="login-header text-center">
          <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
          <h3 class="title hidden">able+</h3>
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="container-fluid">
        <p class="text-center">Click on your username to login</p>
        <ul class="list-group selectable padding-top-base">
          <li
            class="list-group-item avatar login-list-item"
            *ngFor="let user of this.LoggedInUserList"
          >
            <div (click)="onUserFromList(user.username)" class="cursor-pointer">
              <img [src]="user.avatar" class="circle" />
              <strong>{{ user.username }}</strong>
            </div>
            <div class="secondary-content">
              <a
                (click)="onRemoveAccountFromList(user.username)"
                class="cursor-pointer"
                title="Remove account"
              >
                <i class="material-icons">clear</i></a
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer text-center">
      <div class="small">
        <a style="cursor: pointer" (click)="authenticateAsNewUser()">
          <span class="input-group-addon text-center">
            <i class="material-icons"> account_circle</i> Use another account
          </span>
        </a>
      </div>
    </div>
    <hr />
  </div>
</div>
<!--last users accessed end-->
